import React from 'react';
import { navigate } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { Button, buttonBtnTypeData } from '@luigiclaudio/ga-baseline-ui/button';
import { useLoading } from '@luigiclaudio/ga-baseline-ui/helpers';
import { useIdentityContext } from 'react-netlify-identity/dist';

var AuthLogoutButton = function AuthLogoutButton(_ref) {
  var btnType = _ref.btnType;

  var _useIdentityContext = useIdentityContext(),
      user = _useIdentityContext.user,
      logoutUser = _useIdentityContext.logoutUser;

  var _useLoading = useLoading(),
      isLoading = _useLoading[0],
      load = _useLoading[1];

  var handleLogoutUser = function handleLogoutUser() {
    load(logoutUser()).then(function () {
      navigate('/');
    }).catch(function (err) {
      throw err;
    });
  };

  if (!user) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Button, {
    btnType: btnType,
    onClick: handleLogoutUser,
    loading: isLoading
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "auth.logout.button.label"
  }));
};

AuthLogoutButton.defaultProps = {
  btnType: 'link'
};
export default AuthLogoutButton;